// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3n9T6","errors":"Errors_errors__DVKfi"};